// React imports.
import React, { Component } from "react";

// App imports.


const SelectStateAndYear = ({ state }) => (
    <div >
        {state.selectedAssessmentTypeToCreate == "1"
            &&
            <React.Fragment>
                <p><strong>ASSESMENT #1 – Defining Data Requirements:</strong></p>
                <p>
                  This tool is designed to help you assess the reliability of your main heating fuel expenditures data collected in Section V of the LIHEAP Performance Measures Form.  
                </p>
                <p>
                    Throughout the assessment you will be asked to provide ideas that will later be included in your Data Reliability Action Plan. To be clear, these plans will be for your own internal use only. These Action Plans WILL NOT constitute a change or addendum to your State Plan, and OCS WILL NOT hold you to the action items included within them. 
                </p>
                <p>
                To begin, select 
                {state.viewAll === true &&
                    <span >your state and</span>  
                }
                &nbsp;the year you would like to assess below.
                </p>

            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "2"
        &&
            <React.Fragment>
                <p><strong>ASSESMENT #2 – Data Collection:</strong></p>
                <p>
                    Assessment #2 helps you determine whether you are requesting and collecting data from at
                    least the minimum required number of main heating vendors in your state/territory.
                    If you are not requesting or collecting data from the minimum required number of vendors, you may have a
                    data reliability issue and the tool will ask you a series of questions to determine what that issue may be. 
                </p>
                <p>
                    Throughout the assessment you will be asked to provide ideas that will later be included in your Data Reliability Action Plan. To be clear, these plans will be for your own internal use only. These Action Plans WILL NOT constitute a change or addendum to your State Plan, and OCS WILL NOT hold you to the action items included within them. 
                </p>
                <p>
                To begin, select 
                {state.viewAll === true &&
                    <span >your state and</span>  
                }
                &nbsp;the year you would like to assess below.
                </p>
            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "3"
            &&
            <React.Fragment>
                <p><strong>ASSESMENT #3 – Recording and Processing Data:</strong></p>
                <p>
                    Assessment #3 helps you determine whether you were able to get enough of your assisted households to list their main heating fuel vendor on their application and whether you were able to collect main heating expenditure data from enough households to furnish reliable information about the entire population of assisted households for each fuel type in your state/territory.
                </p>
                <p>
                    Throughout the assessment you will be asked to provide ideas that will later be included in your Data Reliability Action Plan. To be clear, these plans will be for your own internal use only. These Action Plans WILL NOT constitute a change or addendum to your State Plan, and OCS WILL NOT hold you to the action items included within them. 
                </p>
                <p>
                    To begin, select 
                    {state.viewAll === true &&
                        <span >your state and</span>  
                    }
                    &nbsp;the year you would like to assess below. If you select a past year for which you submitted a PM Data Form, certain fields in this tool may auto-populate from the LIHEAP Data Warehouse. If you would like to conduct a reliability check on your FY 2019 data, which is currently being reported and processed, you will be given the opportunity to manually fill in the fields using your current FY 2019 PM Data Form.
                </p>
            </React.Fragment>
        }

        {state.selectedAssessmentTypeToCreate == "4"
            &&
            <React.Fragment>
                <p><strong>ASSESMENT #4 – Data Checking Routines:</strong></p>
                <p>
                    Assessment #4 helps you determine whether the data checking routines you have built into your system are robust enough to help ensure data reliability. The more thoroughly your data is checked, the more confident you can be about the level of reliability it provides.
                </p>
                <p>
                    This Assessment consists of several Yes or No Questions. Depending on your answers, the tool will prompt you to provide ideas to address potential gaps in your checking routines. These ideas will later be included in your Data Reliability Action Plan. To be clear, these plans will be for your own internal use only. These Action Plans WILL NOT constitute a change or addendum to your State Plan, and OCS WILL NOT hold you to the action items included within them.
                </p>
                <p>
                    To begin, select 
                    {state.viewAll === true &&
                        <span >your state and</span>  
                    }
                    &nbsp;the year you would like to assess below. If you select a past year for which you submitted a PM Data Form, certain fields in this tool may auto-populate from the LIHEAP Data Warehouse. If you would like to conduct a reliability check on your FY 2019 data, which is currently being reported and processed, you will be given the opportunity to manually fill in the fields using your current FY 2019 PM Data Form.
                </p>
            </React.Fragment>
        }
        {state.selectedAssessmentTypeToCreate == "5"
            &&
            <React.Fragment>
                <p><strong>Overall Reliability Assessment:</strong></p>
                <p>
                    INSTRUCTIONS FOR THE OVERALL ASSESSMENT:
                </p>
                <p>
                    The Overall Reliability Assessment is the starting place for using this tool.  It includes the primary assessment checks for each step of the data reliability framework.  For each of these primary data reliability assessment checks, you will be asked to enter specific information from your most recent performance measures data.  Once you enter the requested information, this tool will assess the information and will alert you when a potential data reliability issue may be present by instructing you to proceed to one of the full assessments for further investigation.
                </p>
                <p>
                    To begin, select 
                    {state.viewAll === true &&
                        <span >your state and</span>  
                    }
                    &nbsp;the year you would like to assess below. If you select a past year for which you submitted a PM Data Form, certain fields in this tool may auto-populate from the LIHEAP Data Warehouse. If you would like to conduct a reliability check on your FY 2019 data, which is currently being reported and processed, you will be given the opportunity to manually fill in the fields using your current FY 2019 PM Data Form.
                </p>
            </React.Fragment>
        }

        Choose your state and year
        <br/><br/>
        {state.UserInfo.viewAll === true &&
            <label>
                Select your state:
                <select className="form-control" style={{height:25,width:"15%"}} id="SelectedGranteeId" value={state.SelectedGranteeId || ''} onChange={state.SelectStateAndYearFieldChangeHandler}>
                        <option >Choose a state</option>
                        {state.Grantees.map(grantee => {
                        return (
                            <option key={grantee.granteeId}  value={grantee.granteeId}>{grantee.granteeName}</option>
                        );
                    })}
                </select>
            </label>
        }
        {state.UserInfo.viewAll != true &&
            <div>Your state: <strong>{state.UserInfo.granteeName}</strong></div>
        }
        {state.SelectedGranteeName != null &&
            <div>Selected state: <strong>{state.SelectedGranteeName}</strong></div>
        }
        <br/>
        Select your year:
        <select className="form-control" style={{height:25,width:"15%"}} id="SelectedYear" value={state.SelectedYear || ''} onChange={state.SelectStateAndYearFieldChangeHandler}>
            <option >Choose a year</option>
            {state.FiscalYears.map(year => {
                return (
                    <option key={year.fiscalYear} value={year.fiscalYear}>{year.fiscalYear}</option>
                );
            })}
        </select>

        <span className="errorMessageText">{state.CreateAssessmentErrorMessage}</span>

        <br /><br />
        <button className="dataButton"
          onClick={() => state.SelectStateAndYearShowPreviousStep()}>
          Previous
        </button>
        <button className="dataButton"
          onClick={() => state.SelectStateAndYearShowNextStep()}
          disabled={state.SelectedGranteeId=== null || state.SelectedGranteeId === 'Choose a state' || state.SelectedYear === 'Choose a year'  || state.SelectedYear === null}>
          Next
        </button>



    </div>
);

export default SelectStateAndYear;
